import React from 'react'
import Contactus from './Countact Us/Contactus'
import Navbar from '../../Components/navbar/Navbar'
import Footer from '../../Components/Footer/Footer'


function ContactPage() {
  return (
    <div>
        <Navbar/>
        <Contactus />
        <Footer />
    </div>
  )
}

export default ContactPage